import { Component, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: (error: Error, reset: () => void) => ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: any) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  reset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError && this.state.error) {
      if (this.props.fallback) {
        return this.props.fallback(this.state.error, this.reset);
      }

      return (
        <div className="p-5 text-center text-red-700 font-bold">
          <h2 className="text-lg mb-2">エラーが発生しました</h2>
          <p className="mb-4">{this.state.error.message}</p>
          <button
            onClick={this.reset}
            className="bg-gradient-to-b from-green-500 to-green-600 text-white px-8 py-2.5 border-2 border-black cursor-pointer text-base font-bold shadow-[2px_2px_0_rgba(0,0,0,0.3)] hover:from-green-600 hover:to-green-700 active:shadow-[1px_1px_0_rgba(0,0,0,0.3)] active:translate-x-[1px] active:translate-y-[1px]"
          >
            再試行
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
